var firestore = firebase.firestore();

var resultsDOM = document.getElementById("searchResults");

var tagsDOM = document.getElementById("searchTags");
var categoriesDOM = document.getElementById("jobCategories");
var typesDOM = document.getElementById("jobTypes");

// Input Elements
var searchInput = document.getElementById("searchInput");
var searchTags = [];

var selectedCategories = [];
var selectedTypes = [];
var searchResults = [];

// Press Enter to click searchBttn
searchInput.addEventListener("keyup", function(event) {
  // Number 13 is the "Enter" key on the keyboard
  if (event.keyCode === 13) {
    // Cancel the default action, if needed
    event.preventDefault();
    // Trigger the button element with a click
    document.getElementById("searchBttn").click();
  }
});

// Utility functions
function getUrlParam(param) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param)
}

function replaceURL(newURL) {
  history.pushState({}, null, newUrl);
}

function cleanData(snapshots) {
    let data = [];
    snapshots.forEach(function(doc) {
        data.push({
            id: doc.id,
            ...doc.data()
        });
    });
    return data;
}

function clearResults() {
  searchResults = [];
  tagsDOM.innerHTML = '';
  resultsDOM.innerHTML = '';
}

function openJob(id) {
  let target = "https://startly.app/pre-register?app=jobs&src=jobs-list&job=" + id;
  window.open(target);
}

// Used when iniitating a new search
function newSearch(collection) {

  var searchQuery = document.getElementById("searchInput").value;

  if (searchQuery !== "") {
    var space_to_plus = function (string) {
      let array = string.trim().split(" ");
      return array.join("+");
    }

    var newURL = "jobs?search=" + (space_to_plus(searchQuery.trim()));

  } else {
    var newURL = "jobs"
  }

  history.pushState({}, null, newURL);

  clearResults();
  startSearch(collection);
}

// Used when iniitating the first search
function startSearch(collection) {

  var keywords = [];
  var searchParams = getUrlParam("search");

  if (searchParams !== null) {
    var string_to_array = function (str) {
        return str.trim().split(" ");
        };

    var query = searchParams.toLowerCase();
    keywords = (string_to_array(query));
    // Get data by collection filtered by keywords from FIrestore & create entries (and tags) in lists
    fetchItems(collection, keywords);
  } else {
    fetchItems(collection);
  }
}

// Create RESULTS
function buildResults (item) {

  var filters = selectedCategories.concat(selectedTypes);

  if (filters.length > 0) {
    if (selectedCategories.includes(item.categoryName)) {
      createItem(item);
    } else if (selectedTypes.includes(item.typeName)) {
      createItem(item);
    } else {}
  }

  else {
    createItem(item);
  }
}

// checkbox functions
function checkedType(type) {
  //TODO
  if (selectedTypes.includes(type)){
    selectedTypes = selectedTypes.filter(item => item !== type)
  } else {
    selectedTypes.push(type)
  }
  clearResults();
  startSearch(listType);
}

function checkedCategory(category) {
  //TODO
  if (selectedCategories.includes(category)){
    selectedCategories = selectedCategories.filter(item => item !== category)
  } else {
    selectedCategories.push(category)
  }
  clearResults();
  startSearch(listType);
}

// Category dom functions
function createType(type) {
    const elem = document.createElement("div");
    elem.setAttribute("class", "field pb-1");

    let typeInner = document.createElement("div");
    typeInner.setAttribute("class", "control");

    let typeCheck = document.createElement("input");
    typeCheck.setAttribute("id", type.name);
    typeCheck.setAttribute("type", "checkbox");
    typeCheck.setAttribute("class", "d-checkbox");
    typeCheck.setAttribute("onChange", "checkedType(this.id);");

    let typeSpacer = document.createElement("span");

    let typeLabel = document.createElement("label");
    typeLabel.setAttribute("class", "checkbox-wrap is-small muted-text");

    typeLabel.append(typeCheck);
    typeLabel.append(typeSpacer);
    typeLabel.append(type.name); // + ' ' + '(' + category.total + ')' ); + ' ' + '(' + type.total + ')' );
    typeInner.append(typeLabel);
    elem.append(typeInner);

    typesDOM.append(elem);
}

function createCategory(category) {
    const elem = document.createElement("div");
    elem.setAttribute("class", "field pb-1");

    let catInner = document.createElement("div");
    catInner.setAttribute("class", "control");

    let catCheck = document.createElement("input");
    catCheck.setAttribute("id", category.name);
    catCheck.setAttribute("type", "checkbox");
    catCheck.setAttribute("class", "d-checkbox");
    catCheck.setAttribute("onChange", "checkedCategory(this.id);");

    let catSpacer = document.createElement("span");

    let catLabel = document.createElement("label");
    catLabel.setAttribute("class", "checkbox-wrap is-small muted-text");

    catLabel.append(catCheck);
    catLabel.append(catSpacer);
    catLabel.append(category.name); // + ' ' + '(' + category.total + ')' );
    catInner.append(catLabel);
    elem.append(catInner);

    categoriesDOM.append(elem);
}

// JobResults dom functions
function createItem(item) {

    const elem = document.createElement("div");
    elem.setAttribute("id", item.id);
    elem.setAttribute("class", "result-list-item");
    elem.setAttribute("onClick", "openJob(this.id);");

    let elemImg = document.createElement("img");
    elemImg.setAttribute("src", item.img);

    let elemMeta = document.createElement("div");
    elemMeta.setAttribute("class", "meta");

    let elemName = document.createElement("span");
    elemName.innerText = item.name;

    let elemDetails = document.createElement("div");
    elemDetails.setAttribute("class", "details");

    let elemCompany = document.createElement("span");
    elemCompany.innerText = item.companyName;

    let elemSpacer = document.createElement("span");
    elemSpacer.setAttribute("class", "spacer");
    elemSpacer.innerText = "|";

    let elemLocation = document.createElement("span");
    elemLocation.innerText = item.typeName;

    let elemEnd = document.createElement("div");
    elemEnd.setAttribute("class", "end");

    let elemLevel = document.createElement("span");
    elemLevel.setAttribute("class", "tag is-rounded is-secondary");
    elemLevel.innerText = item.badge;

    let elemDuration = document.createElement("span");
    elemDuration.setAttribute("class", "time");
    elemDuration.innerText = item.duration;

    elemEnd.append(elemLevel);
    elemEnd.append(elemDuration);

    elemDetails.append(elemCompany);
    elemDetails.append(elemSpacer);
    elemDetails.append(elemLocation);

    elemMeta.append(elemName);
    elemMeta.append(elemDetails);

    elem.append(elemImg);
    elem.append(elemMeta);
    elem.append(elemEnd);

    resultsDOM.append(elem);
}

function createTag(tag) {
    const elem = document.createElement("span");
    elem.setAttribute("class", "tag is-rounded");
    elem.innerText = tag;

    tagsDOM.append(elem);
}

// Firebase functions
function fetchTypes() {
    return firestore
        .collection("types").orderBy("order")
        //TODO: fetch Jobs, compare category of current job with current category, get length of TRUE
        .get()
        .then((snapshots) => cleanData(snapshots))
        .then((types) => types.map((type) => createType(type)));
}

function fetchCategories() {
    return firestore
        .collection("categories").orderBy("order")
        //TODO: fetch Jobs, compare category of current job with current category, get length of TRUE
        .get()
        .then((snapshots) => cleanData(snapshots))
        .then((categories) => categories.map((category) => createCategory(category)));
}

function fetchItems(collection, keywords) {

  var searchQuery = document.getElementById("searchInput").value

    if (keywords == null) {
      return firestore
      .collection(collection).orderBy("created")
      .get()
      .then((snapshots) => cleanData(snapshots))
      .then((items) => items.map((item) => buildResults(item)));
    } else {

      // var keywords = tags.toLowerCase();
      keywords.forEach(tag => createTag(tag));
      searchInput.value= ""


        return firestore
            .collection(collection).where('keywords', 'array-contains-any', keywords).orderBy("created")
            .get()
            .then((snapshots) => cleanData(snapshots))
            .then((items) => items.map((item) => buildResults(item)));

    }
}
